let currentItems = {};

export function setHookCheckoutItems(items) {
  currentItems = items;
}

export function getHookCheckoutItems() {
  return currentItems;
}
